import React, { useState, useEffect, useRef } from 'react'
import { WMSTileLayer, MapContainer, TileLayer, LayerGroup, Map, LayersControl, ZoomControl, ScaleControl, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import * as L from 'leaflet';
import { useLocation } from 'react-router-dom';
import LayerLegend from '../components/map/LayerLegend';
import 'leaflet-fullscreen/dist/Leaflet.fullscreen';
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import InitialPositionButton from '../components/map/InitialPositionButton';
import RemoveLayersButton from '../components/map/RemoveLayersButton';
import DownloadShapeButton from '../components/map/DownloadShapeButton';
import Watermark from '../components/map/Watermark';
import BaseLayersComponent from '../components/map/BaseLayersComponent';
import './Map.css';
// import MeasureComponent from '../components/map/MeasureComponent';

import 'leaflet-timedimension/src/leaflet.timedimension';
import 'leaflet-timedimension/src/leaflet.timedimension.layer';
import 'leaflet-timedimension/src/leaflet.timedimension.control';
import 'leaflet-timedimension/src/leaflet.timedimension.player';
import 'leaflet-timedimension/src/leaflet.timedimension.util';
import 'leaflet-timedimension/src/leaflet.timedimension.control.css';
import 'leaflet-timedimension/src/leaflet.timedimension.layer.wms';
import RulerComponent from '../components/map/RulerComponent';
// import TimeLineComponent from '../components/map/TimeLineComponent';

export default function MapComponent() {
  const initialPostion = [process.env.REACT_APP_MAP_INITIALPOSITION_LATITUDE, process.env.REACT_APP_MAP_INITIALPOSITION_LONGITUDE]
  const [position, setPosition] = useState(initialPostion);
  const [zoom, setZoom] = useState([]);
  const [layers, setLayers] = useState([]);
  const location = useLocation();
  const { currentLayer } = location.state;
  const [legend, setLegend] = useState('');
  const geoserverWmsUrl = process.env.REACT_APP_GEOSERVER_WMS;
  const { BaseLayer } = LayersControl;
  // const [map, setMap] = useState();
  let mapRef = useRef(null);

  useEffect(() => {
    refreshLayers();
    setLegend(process.env.REACT_APP_GEOSERVER_GETLEGENDGRAPHIC + String(currentLayer.Name));

    let localizacao = getLocalizacao();
    if (localizacao[0] !== position[0]) {
      setPosition([localizacao.latitude, localizacao.longitude]);
      setZoom(localizacao.zoom);
    }
  }, [currentLayer]);

  const refreshLayers = () => {
    const _layers = [];
    layers.forEach(layer => {
      if (layer.Name[0] != currentLayer.Name[0])
        _layers.push(layer)
    });
    _layers.push(currentLayer);
    setLayers(_layers);
  }

  const getLocalizacao = () => {
    const keywords = currentLayer.KeywordList[0].Keyword;
    let localizacao = {};
    localizacao.latitude = process.env.REACT_APP_MAP_INITIALPOSITION_LATITUDE;
    localizacao.longitude = process.env.REACT_APP_MAP_INITIALPOSITION_LONGITUDE;
    localizacao.zoom = 7;
    keywords.forEach(item => {
      const keyword = item.split(':')[0];
      if (keyword == 'localizacao') {
        const atributos = item.split(':')[1];
        localizacao.latitude = atributos.split(',')[0];
        localizacao.longitude = atributos.split(',')[1];
        localizacao.zoom = parseInt(atributos.split(',')[2]) ?? 7;
      }
    });
    return localizacao;
  }

  return (
    <>
      {legend ? <LayerLegend url={legend} layer={currentLayer} /> : null}
      <MapContainer id='mapContainer'
        center={position}
        zoom={6}
        scrollWheelZoom={true}
        zoomControl={false}
        fullscreenControl={{ position: 'topright' }}
        style={{ width: '100%', height: '95%', marginLeft: '0px', marginTop: '', position: 'absolute' }}
      // timeDimension={true}
      // timeDimensionControl={true}
      // whenCreated={setMap}
      // ref={mapRef}

      >
        {/* <MeasureComponent></MeasureComponent> */}
        <ScaleControl imperial={false} position='bottomleft' />
        <ZoomControl position='topright' />

        <LayersControl position="topright" collapsed={true} autoZIndex={true}>

          <BaseLayersComponent layer={currentLayer} />

          <LayerGroup>

            <InitialPositionButton position={position} zoom={zoom} />
            <RemoveLayersButton
              removeLayers={() => setLayers([])}
              removeLegend={() => setLegend(null)}
            />
            <DownloadShapeButton layersList={layers} />
            <Watermark />
            <RulerComponent></RulerComponent>
            {/* <TimeLineComponent></TimeLineComponent> */}


            {layers.map((item) =>
              <LayersControl.Overlay
                key={item.Title + 'control'}
                checked={true}
                name={`
                <b className='ml-2' style='text-transform: Uppercase;' > ${item.Title}  </b> 
                <div style='width: 600px;'> <p > ${item.Abstract} </p> </hr> </div>
              `}
              >
                <WMSTileLayer
                  layers={item.Name}
                  url={geoserverWmsUrl}
                  transparent={true}
                  format={'image/png'}
                  key={item.Name + Math.random()}
                  eventHandlers={{
                    remove: (e) => {
                      console.log('EventHandlers.remove:', e);
                    },

                  }}
                >
                </WMSTileLayer>
              </LayersControl.Overlay>
            )}

          </LayerGroup>
        </LayersControl>
      </MapContainer>
    </>
  )
}